.cardAttributes {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

/* label = the first child (uppercase name) */
.cardAttributes > :first-child {
  letter-spacing: 0.045em;
}

.attributeValueWithBtn {
  display: flex;
  align-items: center;
  gap: 1rem;
  font-variant-numeric: tabular-nums lining-nums;
}

.editAction {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}

@media only screen and (max-width: 550px) {
  .attributeValueWithBtn {
    gap: 0;
  }
}
